<template>
  <div
    class="kk-tabs__content"
    :class="{
      'kk-tabs__content--active': $parent.$props.activeTabName === name,
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'KkTabsContent',
  props: {
    name: {
      type: String,
      required: true,
    },
  },
};
</script>
